import {ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Reservation, ReservationStatus} from "crqlar-react-common/dist/models/reservation/reservation.model";
import {getEventBackgroundColor, getEventColorBasedOnStatus} from "crqlar-react-common/dist/utils/color.util";
import {getReservationStatusOptions} from '../reservationStatusOptions';

interface Props {
    reservation?: Reservation
    setReservation: (reservation: Reservation) => void
    size?: "small" | "large" | "medium" | undefined
    direction?: "row" | "column"
    compact?: boolean
}

const ReservationStatuses = ({
                                 reservation,
                                 setReservation,
                                 size,
                                 direction = "row",
                                 compact = false
                             }: Props) => {

    //region State

    const {t} = useTranslation()

    //endregion State

    //region UI

    const renderStatusToggle = (status: ReservationStatus) => {
        const color = getEventColorBasedOnStatus(status)
        const backgroundColor = getEventBackgroundColor(status)

        return (
            <ToggleButton
                key={status}
                value={status}
                sx={{
                    borderRadius: '0px',
                    '&.Mui-selected': {
                        color: color,
                        backgroundColor: backgroundColor,
                        border: `1px solid ${color}`
                    },
                    '&.Mui-selected:hover': {
                        backgroundColor: backgroundColor
                    },
                    flex: { xs: '1 0 calc(33.33% - 1px)', sm: 'unset' }
                }}
            >
                <Typography
                    variant={'body2'}
                    sx={{ whiteSpace: 'nowrap', ...(compact && { fontSize: '0.6rem' }) }}
                >
                    {t(`Reservation status ${status}`)}
                </Typography>
            </ToggleButton>
        )
    }

    return (
        <ToggleButtonGroup
            id={'status'}
            value={reservation?.status}
            onChange={(e, value) => {
                // Only allow changing status if value is not null
                // This way we prevent from saving the reservation without a status which can cause issues
                if (value) {
                    setReservation({
                        ...reservation,
                        status: value as ReservationStatus
                    })
                }
            }}
            exclusive
            size={size ?? 'large'}
            orientation={direction === "column" ? "vertical" : "horizontal"}
            sx={{
                display: 'flex',
                flexDirection: direction === "column" ? 'column' : 'row',
                flexWrap: direction === "column" ? 'nowrap' : { xs: 'wrap', sm: 'nowrap' },
                gap: direction === "column" ? 1 : 0
            }}
        >
            {getReservationStatusOptions(!!reservation?.id, reservation?.status ? [reservation.status] : [])
                .map(renderStatusToggle)}
        </ToggleButtonGroup>
    )

    //endregion UI

}


export default ReservationStatuses
